import AssetFormWrapper from "../../components/asset-forms/AssetFormWrapper";

/**
 * Property Asset Edit View
 * Now uses the unified AssetFormWrapper component
 */
const PropertyView = ({ assetId, startInEditMode }) => {
  return (
    <AssetFormWrapper
      mode="edit"
      subCategory="property"
      assetId={assetId}
      startInEditMode={startInEditMode}
    />
  );
};

export default PropertyView;
